
import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { Modal, Button, Badge, Timeline, Divider, Icon } from 'antd';
import { RuleOperationsService, IStackTraceMessage } from 'src/app/rules/rules/rule-services';
import { resolve } from 'inversify-react';
import { FormatService } from "src/core/services/format.service";

interface TruncatedTextViewProps {
	value: string;
	maxSize?: number;
	header?: any;
	footer?: any;
}

@observer
export class TruncatedTextView extends React.Component<TruncatedTextViewProps, any> {
	constructor(props: any) {
		super(props);

		this.collapsed = true;
	}

	@resolve
	formatService: FormatService;

	@observable
	collapsed: boolean;

	private trunk(line: string, count: number = 50) {


		if (!!line && line.length > count && this.collapsed) {
			return line.substr(0, count);
		}

		return line;
	}

	render() {

		return (
			<p style={{ whiteSpace: 'pre-line' }}> {this.props.header} {!this.collapsed && < a style={{ marginLeft: '5px' }} onClick={() => this.collapsed = !this.collapsed}>...</a>} {this.trunk(this.props.value, this.props.maxSize)}

				{this.props.value && this.props.value.length > this.props.maxSize && < a style={{ marginLeft: '5px' }} onClick={() => this.collapsed = !this.collapsed}>...</a>} {this.props.footer } </p >
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/stacktrace/parts/truncated-text.view.tsx